import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Pagination = ({ totalPages, currentPage, setCurrentPage }) => {
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <ul className="pagination">
      <li className="page-item">
        <button
          className="page-link arrow"
          aria-label="previous"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <FaChevronLeft />
        </button>
      </li>

      {[...Array(totalPages)].map((_, i) => (
        <li className="page-item" key={i}>
          <button
            className={`page-link ${currentPage === i + 1 ? "current" : ""}`}
            onClick={() => goToPage(i + 1)}
          >
            {i + 1}
          </button>
        </li>
      ))}

      <li className="page-item">
        <button
          className="page-link arrow"
          aria-label="next"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <FaChevronRight />
        </button>
      </li>
    </ul>
  );
};

export default Pagination;
